import Vue from 'vue'
import { format as formatDate } from 'date-fns'

Vue.filter('formatDateTime', date => formatDate(date, 'DD/MM/YY HH:mm'))
